import { render, staticRenderFns } from "./serviceEnquiryList.vue?vue&type=template&id=16c306d5"
import script from "./serviceEnquiryList.vue?vue&type=script&lang=js"
export * from "./serviceEnquiryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports